import React from "react"
import { IIconProps } from "./Icon/Interfaces"

const ExitIcon = ({ width = 32, height = 32, strokeColor = "var(--blue)" }: IIconProps) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 25 20"
			fill={strokeColor}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.1641 7C16.4402 7 16.6641 6.77614 16.6641 6.5V4.10188C16.6641 3.6723 17.17 3.44272 17.4933 3.7256L24.234 9.62371C24.4617 9.82292 24.4617 10.1771 24.234 10.3763L17.4933 16.2744C17.17 16.5573 16.6641 16.3277 16.6641 15.8981V13.5C16.6641 13.2239 16.4402 13 16.1641 13H9.16406C8.88792 13 8.66406 12.7761 8.66406 12.5V7.5C8.66406 7.22386 8.88792 7 9.16406 7H16.1641ZM1.16406 0C0.88792 0 0.664062 0.223858 0.664062 0.5V19.5C0.664062 19.7761 0.88792 20 1.16406 20H14.1641C14.4402 20 14.6641 19.7761 14.6641 19.5V18.5C14.6641 18.2239 14.4402 18 14.1641 18H3.16406C2.88792 18 2.66406 17.7761 2.66406 17.5V2.5C2.66406 2.22386 2.88792 2 3.16406 2H14.1641C14.4402 2 14.6641 1.77614 14.6641 1.5V0.5C14.6641 0.223858 14.4402 0 14.1641 0H1.16406Z"
				fill={strokeColor}
			/>
		</svg>
	)
}

export default ExitIcon
